import Alert from '@anm/components/notification/Alert';
import { getExtraChargeMessage } from '@anm/data/profile/subscriptionLimits';
import { FC } from 'react';

import { getExtraTraffic } from '../helpers';
import { ExtraChargeAlertProps } from '../types';

import { AlertContent } from './Wrapper';

const ExtraChargeAlert: FC<ExtraChargeAlertProps> = ({
  used,
  name,
  planName,
  available,
  diffBytes,
  extraCharge,
  extraItemCost,
  isMonthLimit
}) => (
  <Alert position="left" variant="info">
    <AlertContent>
      <p dangerouslySetInnerHTML={{ __html: getExtraChargeMessage(name, available, extraItemCost, planName) }} />
      <br />
      <p>
        Extra {name}: {getExtraTraffic({ used, available, diffBytes }).join(' ')}.
      </p>
      <p>
        Extra {name} charges: {getExtraTraffic({ used, available, diffBytes }).join(' ')} × {extraItemCost}¢ =&nbsp;
        <b>
          ${extraCharge / 100}
          {isMonthLimit ? '/month' : ''}
        </b>
      </p>
    </AlertContent>
  </Alert>
);

export default ExtraChargeAlert;
